/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Toast_Update_PnkInputs */

const vi_pkl_toast_update_pnk = /** @type {(inputs: Pkl_Toast_Update_PnkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu thay đổi phiếu nhập vật tư`)
};

/**

* @param {Pkl_Toast_Update_PnkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_toast_update_pnk = /** @type {((inputs?: Pkl_Toast_Update_PnkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Toast_Update_PnkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_toast_update_pnk(inputs)
});